import { InputWithOptionsDriver } from '../InputWithOptions/InputWithOptions.driver';

export type DropdownDriver = InputWithOptionsDriver;
